
import { useState } from 'react';
import { type Gift, type Brand } from '@/utils/types';

export function useInventorySelection(initialGifts: Gift[]) {
  const [selectedGift, setSelectedGift] = useState<Gift | null>(null);
  const [targetGift, setTargetGift] = useState<Gift | null>(null);
  const [targetEmail, setTargetEmail] = useState('');
  const [gifts, setGifts] = useState<Gift[]>(initialGifts);
  const [currentBrand, setCurrentBrand] = useState<Brand | null>(null);
  
  const handleGiftSelect = (gift: Gift) => {
    console.log("Selected gift:", gift.id);
    setSelectedGift(gift);
    setTargetGift(null);
    setTargetEmail('');
  };
  
  return {
    selectedGift,
    targetGift,
    targetEmail,
    gifts,
    currentBrand,
    setSelectedGift,
    setGifts,
    setTargetGift,
    setTargetEmail,
    setCurrentBrand,
    handleGiftSelect,
  };
}
